import { LicencePlate } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { tDefaults } from '../../../infrastructure/internationalisation'
import { Formatter } from '../types'

export const VehicleRegistrationFormatter: FunctionComponent<Formatter<string>> = ({
  value,
  size,
  t,
}) =>
  value ? (
    <LicencePlate size={size} licencePlate={value} />
  ) : (
    t(tDefaults('inputs.no-answer'))
  )
